import * as React from "react";
import { Row, Col } from "react-bootstrap";
import "./Animation.scss";

// Smile Icon
// Render a single Smile Icon
function Smile(props) {
  return <i className="px-smile" id={"smile-" + props.index} />;
}

// Smile Icons Group
// Render a whole row of Smiles
function SmileGroup(props) {
  let rowContents = [];
  const smileRowCount = props.count;

  for (var i = 0; i < smileRowCount; i++) {
    rowContents.push(<Smile key={props.start + i} index={props.start + i} />);
  }
  return rowContents.reverse();
}

// SmileGroup Rows
// Render all the rows of Smiles
function SmilesGroupRender(props) {
  let content = [];
  for (var i = 0; i < props.rows; i++) {
    content.push(
      <Row
        key={i}
        className="col-lg-12 col-md-12 col-12 pe-1 d-flex align-items-end smile-group-row"
      >
        <Col className="col-lg-12 col-md-12 col-12 smile">
          <SmileGroup
            count={props.smilesRowCounts[i]}
            start={props.smilesOffsets[i]}
          />
        </Col>
      </Row>
    );
  }
  return content.reverse();
}

const SmileGroupAnimation = () => {
  //DESKTOP DEFAULT

  // Smiles per row
  const smilesRowCounts = [];
  smilesRowCounts[0] = 3;
  smilesRowCounts[1] = 4;
  smilesRowCounts[2] = 5;
  smilesRowCounts[3] = 4;
  smilesRowCounts[4] = 5;

  // Smiles offset
  const smilesOffsets = [];
  smilesOffsets[0] = 1;
  smilesOffsets[1] = 4;
  smilesOffsets[2] = 8;
  smilesOffsets[3] = 13;
  smilesOffsets[4] = 17;

  // Total rows
  const rows = 5;

  return (
    <SmilesGroupRender
      rows={rows}
      smilesRowCounts={smilesRowCounts}
      smilesOffsets={smilesOffsets}
    />
  );
};

export default SmileGroupAnimation;
